
import GeoLocationEngine from './GeoLocationEngine.js';
import FakeGeoLocationEngine from './FakeGeoLocationEngine.js';
import LocationTween from './locationTween';
import { GeoLocationMessage } from './geoLocation';
import { BaseEventListener } from './BaseEventListener.js';
import { localStorage, LocalStorageKeys } from './LocalStorage.js';
import { Config } from './config';
import { identity } from 'svelte/internal';

class GeoLocationManager extends BaseEventListener
{
    constructor(){
        super();
        this._currentEngine = Config.use_fake_geo_location_provider ? new FakeGeoLocationEngine() : new GeoLocationEngine();

        this._tween = null;
        this._fromCoords = null;
        this._currentCoords = null;

        this._started = false;

        this._serviceState = this.__getStateFromLocalStorage();

        this._newCoordsHandler = this.onNewCoords.bind(this);

        console.log("geo location state at init", this._serviceState);
    }

    __getStateFromLocalStorage(){
        const state = localStorage.get(LocalStorageKeys.geo_location_state);
        console.log("state", state);
        if(state === null){
            console.log("state", state);
            return GeoLocationServiceState.UNKNOWN;
        }

        return state;
    }

    __setState(newState){
        if(newState === this._serviceState) return;

        this._serviceState = newState;
        localStorage.set(LocalStorageKeys.geo_location_state, newState);
    }

    get isStarted(){
        return this._started;
    }

    get serviceState(){
        return this._serviceState;
    }

    get currentCoords(){
        if(this._serviceState == GeoLocationServiceState.WORKING && this._currentCoords){
            return GeoLocationMessage.newCoords(this._currentCoords.slice());
        }else {
            return null;
        }
    }

    // initMap(aMap){
    //     console.log("init map");
    //     this.fakeGeolocationEngine.initMap(aMap);
    // }


    onNewCoords(coordsMessage){
        console.log("on new coords in geolocationManager", coordsMessage);
        if(coordsMessage.error){

            // handle critical cases
            if(coordsMessage.error.code == 42){
                this.__setState(GeoLocationServiceState.UNSUPPORTED_DEVICE);
            }else if(coordsMessage.error.code == 1){
                this.__setState(GeoLocationServiceState.PERMISSION_DENIED);
            }
            this.provide(GeolocationEventType.locationError, coordsMessage);
            this.stop();
            return;
        }

        // this is a significant geoLocation change
        this.provide(GeolocationEventType.significantCoords, coordsMessage);

        this.__setState(GeoLocationServiceState.WORKING);

        if(this._tween && this._tween.isTweening){
            this._tween.stop();
            this._fromCoords = this._currentCoords.slice();
        }

        const tweenStep = (nextCoords) => {
            this.provide(GeolocationEventType.coords, GeoLocationMessage.newCoords(nextCoords.slice()));
            this._currentCoords = nextCoords.slice();
        }

        const tweenComplete = (nextCoords) => {
            this.provide(GeolocationEventType.coords, GeoLocationMessage.newCoords(nextCoords.slice()));
            this._fromCoords = nextCoords.slice();
        }

        // const tweenDuration = Config.useFakeGpsProvider ? 4000 : 1000; // ms
        const tweenDuration = 4000; // ms

        if(this._fromCoords){
            this._tween = new LocationTween(this._fromCoords, coordsMessage.coords, tweenDuration, tweenStep, tweenComplete);
            this._tween.start();
        }else{
            this._fromCoords = coordsMessage.coords;
        }

    }


    start(){
        if(this._started) return;

        this._started = true;
        this._currentEngine.start();
        this._currentEngine.addListener(this._newCoordsHandler);
        this.provide(GeolocationEventType.started, null);
        console.log("geoLocationManager started");
    }

    stop(){
        if(!this._started) return;
        
        if(this._tween && this._tween.isTweening){
            this._tween.stop();
        }
        this._currentEngine.stop();
        this._currentEngine.removeListener(this._newCoordsHandler);
        this._started = false;
        this._fromCoords = null;
        this.provide(GeolocationEventType.stopped, null);
        console.log("geoLocationManager stopped");
    }

}

export const GeoLocationServiceState = {
    UNKNOWN: "UNKNOWN",
    PERMISSION_DENIED: "PERMISSION_DENIED",
    UNSUPPORTED_DEVICE: "UNSUPPORTED_DEVICE",
    WORKING: "WORKING",
};

export const GeolocationEventType = {
    locationError: "locationError",
    coords: "coords",
    significantCoords: "significantcoords",
    started: "started",
    stopped: "stopped",
};

export const geoLocationManager = new GeoLocationManager();